import { Typography } from '@smartgift/frontend-toolkit';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterOptions } from './context';
import { TableSelectFilter } from './CustomSelect';
import * as S from './style';

function TableFilter({
  table,
  tableRef,
  value = [],
  options = [],
  placeholder,
  onFilterChange,
  components,
  inputPlaceholderOnMenu,
  globalFilters,
  hideSearchOnMenu,
  ...props
}) {
  const { t } = useTranslation();

  const inputPlaceholder = useMemo(
    () => inputPlaceholderOnMenu || placeholder,
    [inputPlaceholderOnMenu, placeholder]
  );

  if (components?.Filter) {
    return (
      <components.Filter
        globalFilters={globalFilters}
        value={value}
        options={options}
        placeholder={placeholder}
        onFilterChange={onFilterChange}
        table={table}
        {...props}
      />
    );
  }

  return (
    <S.Wrapper>
      <FilterOptions.Provider
        value={{
          inputPlaceholderOnMenu: inputPlaceholder,
          hideSearchOnMenu
        }}
      >
        <Typography style={{ marginRight: 8 }} as="span" variant="body2SemiBold">
          {t('filterBy') + ':'}
        </Typography>
        <TableSelectFilter
          tableRef={tableRef}
          options={options}
          onChange={onFilterChange}
          selectedOption={value}
          placeholder={placeholder}
          {...props}
        />
      </FilterOptions.Provider>
    </S.Wrapper>
  );
}

export { TableFilter };
